module.exports = __webpack_public_path__ + "img/wechat.9f5945ac.png";